import { useQuery } from '@tanstack/react-query';
import { getTherapyTypes } from '@uplift/api';

export const useModalitiesQuery = () => {
  return useQuery({
    queryKey: [ 'modalities' ],
    queryFn: getTherapyTypes,
    select: data => data.therapyTypes
  });
};
